const XLSX = require('xlsx');

export default function generateXSLX(records) {
  const workSheet = XLSX.utils.json_to_sheet(records);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, 'DeathNotices');

  return XLSX.write(workBook, { bookType: 'xlsx', type: 'buffer' });
}
